// /scripts/lib/data.js
import { customizationGroups } from "./customization-options.js";

/** @type {Product[]} */
export const products = [
  {
    id: "prod-001",
    name: "Pastel Rose Bouquet",
    category: "Flowers",
    subCategory: "Real Flowers",
    price: 75.0,
    description: "A stunning arrangement of hand-picked pastel roses, perfect for any occasion.",
    imageId: "product-flower-1",
  },
  {
    id: "prod-002",
    name: "Rustic Wildflower Mix",
    category: "Flowers",
    subCategory: "Real Flowers",
    price: 60.0,
    description: "A charming mix of seasonal wildflowers, bringing a touch of nature indoors.",
    imageId: "product-flower-2",
  },
  {
    id: "prod-009",
    name: "Faux Peony Bundle",
    category: "Flowers",
    subCategory: "Synthetic Flowers",
    price: 45.0,
    description: "Lifelike synthetic peonies that offer everlasting beauty without the maintenance.",
    imageId: "product-flower-3",
  },
  {
    id: "prod-010",
    name: "Dried Lavender Bunch",
    category: "Flowers",
    subCategory: "Dried Flowers",
    price: 25.0,
    description: "A fragrant bunch of dried lavender, perfect for decor or potpourri.",
    imageId: "product-flower-4",
  },
  {
    id: "prod-011",
    name: "Mini Fiddle Leaf Fig",
    category: "Flowers",
    subCategory: "Small Plants",
    price: 55.0,
    description: "A popular and stylish small indoor tree to liven up any space.",
    imageId: "product-plant-1",
  },
  {
    id: "prod-012",
    name: "Decorative Birch Twigs",
    category: "Flowers",
    subCategory: "Wood Sticks",
    price: 20.0,
    description: "Natural birch twigs to add a rustic, minimalist touch to your decor.",
    imageId: "product-wood-sticks",
  },
  {
    id: "prod-003",
    name: "Lavender Dream Soap",
    category: "Soaps",
    subCategory: "Elegant",
    price: 12.0,
    description: "Calming handmade soap infused with pure lavender essential oil and shea butter.",
    imageId: "product-soap-1",
  },
  {
    id: "prod-004",
    name: "Zesty Citrus Bar",
    category: "Soaps",
    subCategory: "Sweet",
    price: 12.0,
    description: "An invigorating artisanal soap with a blend of lemon, orange, and grapefruit oils.",
    imageId: "product-soap-2",
  },
  {
    id: "prod-013",
    name: "Oatmeal & Honey Soap",
    category: "Soaps",
    subCategory: "Gourmet",
    price: 13.0,
    description: "A comforting and exfoliating soap made with real honey and ground oats.",
    imageId: "product-soap-oatmeal",
  },
  {
    id: "prod-014",
    name: "Amber & Myrrh Soap",
    category: "Soaps",
    subCategory: "Oriental",
    price: 14.0,
    description: "An exotic and mysterious scent with notes of rich amber and sacred myrrh.",
    imageId: "product-soap-amber",
  },
  {
    id: "prod-015",
    name: "Cedarwood & Sage Soap",
    category: "Soaps",
    subCategory: "Woody",
    price: 13.0,
    description: "A grounding and earthy soap with a blend of cedarwood and clary sage oils.",
    imageId: "product-soap-cedarwood",
  },
  {
    id: "prod-016",
    name: "Baby Powder Fresh Soap",
    category: "Soaps",
    subCategory: "Powdery",
    price: 12.0,
    description: "A soft and gentle soap with the classic, clean scent of baby powder.",
    imageId: "product-soap-powder",
  },
  {
    id: "prod-017",
    name: "Spiced Pumpkin Soap",
    category: "Special Edition",
    price: 15.0,
    description: "A limited edition Halloween soap with a warm, spicy pumpkin fragrance.",
    imageId: "product-soap-halloween",
  },
  {
    id: "prod-005",
    name: "Gilded Agate Coasters",
    category: "Ceramic & Pottery",
    subCategory: "Coasters",
    price: 45.0,
    description: "A set of four elegant agate coasters with beautiful gold-leafed edges.",
    imageId: "product-decor-1",
  },
  {
    id: "prod-006",
    name: "Minimalist Ceramic Holders",
    category: "Ceramic & Pottery",
    subCategory: "Vases",
    price: 35.0,
    description: "A pair of sleek, modern ceramic holders for your favorite taper candles.",
    imageId: "product-decor-2",
  },
  {
    id: "prod-007",
    name: "Ocean Breeze Candle",
    category: "Candles",
    subCategory: "Jar Candle",
    price: 25.0,
    description: "A fresh, clean scent of sea salt and orchid in a soy wax candle.",
    imageId: "product-candle-1",
  },
  {
    id: "prod-008",
    name: "Sandalwood & Vanilla Candle",
    category: "Candles",
    subCategory: "Jar Candle",
    price: 28.0,
    description: "A warm and cozy blend of sandalwood and vanilla for a relaxing ambiance.",
    imageId: "product-candle-2",
  },
  {
    id: "prod-018",
    name: "Peony Shaped Candle",
    category: "Candles",
    subCategory: "Shaped Candle",
    price: 22.0,
    description: "A beautiful, unscented candle shaped like a blooming peony flower.",
    imageId: "product-candle-shaped-flower",
  },
  {
    id: "prod-019",
    name: "Teddy Bear Candle",
    category: "Candles",
    subCategory: "Shaped Candle",
    price: 18.0,
    description: "A cute, unscented candle in the shape of a teddy bear, perfect for baby showers.",
    imageId: "product-candle-shaped-teddy",
  },
  {
    id: "prod-020",
    name: "Amber Glass Jar Candle",
    category: "Candles",
    subCategory: "Jar Candle",
    price: 30.0,
    description: "A sophisticated candle in an amber glass jar, scented with fig and honey.",
    imageId: "product-candle-jar-amber",
  },
];

export const scentPairings = {
  "relaxing-party-adults": {
    blendName: "Serene Social",
    oils: ["Lavender", "Bergamot", "Frankincense"],
    description: "A calming yet sophisticated blend to encourage relaxed conversation and a peaceful atmosphere.",
    decor: "Soft lighting with candles, plush cushions, and arrangements of baby's breath.",
    imageId: "scent-relaxing",
  },
  "energizing-party-teens": {
    blendName: "Vibrant Vibe",
    oils: ["Sweet Orange", "Peppermint", "Grapefruit"],
    description: "An upbeat and zesty aroma to boost energy and fun for a lively teen party.",
    decor: "Colorful streamers, neon lights, and fun photo booth props.",
    imageId: "scent-energizing",
  },
  "romantic-wedding-all": {
    blendName: "Eternal Bloom",
    oils: ["Rose", "Ylang Ylang", "Sandalwood"],
    description: "A deeply romantic and heartwarming scent, perfect for celebrating love.",
    decor: "Flowing fabrics, rose petal scatters, and warm, golden fairy lights.",
    imageId: "scent-romantic",
  },
  default: {
    blendName: "Signature Blend",
    oils: ["Chamomile", "Geranium", "Clary Sage"],
    description: "A balanced and harmonious blend suitable for any occasion.",
    decor: "Natural wood elements, fresh greenery, and neutral-toned linens.",
    imageId: "hero-home",
  },
};

export const subscriptionScents = [
  { id: "scent-1", name: "Lavender Fields", profile: "Floral" },
  { id: "scent-2", name: "Coastal Breeze", profile: "Fresh" },
  { id: "scent-3", name: "Sandalwood Serenity", profile: "Woody" },
  { id: "scent-4", name: "Spiced Citrus", profile: "Spicy" },
  { id: "scent-5", name: "Vanilla Bean", profile: "Sweet" },
];

export const subscriptionDecorStyles = [
  { id: "style-1", name: "Modern Minimalist", description: "Clean lines, neutral colors, and simple forms." },
  { id: "style-2", name: "Bohemian Chic", description: "Earthy tones, natural textures, and free-spirited patterns." },
  { id: "style-3", name: "Classic Elegance", description: "Timeless designs, refined details, and a touch of luxury." },
];

export const culinaryPartners = [
  {
    id: "sweet-delights-patisserie",
    name: "Sweet Delights Patisserie",
    specialty: "Sweet",
    description: "Exquisite cakes, pastries, and sweet treats for any celebration.",
    imageId: "culinary-sweet-1",
    offerings: [
      {
        id: "offering-choux-eclair",
        name: "Choux & Éclairs",
        description: "Light and airy choux pastry, available as classic choux buns or elegant éclairs.",
        imageId: "offering-choux-eclair",
        customizationGroups: [
          customizationGroups.chouxEclairType,
          customizationGroups.chouxEclairBaseFlavor,
          customizationGroups.chouxEclairFillingType,
          customizationGroups.chouxEclairFillingFlavor,
          customizationGroups.chouxEclairToppingFlavor,
        ],
      },
      {
        id: "offering-paris-brest",
        name: "Paris-Brest",
        description: "A classic French dessert, made of choux pastry and a praline flavoured cream.",
        imageId: "offering-paris-brest",
        customizationGroups: [customizationGroups.nuts],
      },
      {
        id: "offering-macarons",
        name: "Artisanal Macarons",
        description: "Delicate and flavorful macarons in a variety of classic and seasonal flavors.",
        imageId: "offering-macarons",
        customizationGroups: [
          customizationGroups.macaronShell,
          customizationGroups.macaronFilling,
          customizationGroups.macaronHeart,
        ],
      },
      {
        id: "offering-cupcakes",
        name: "Gourmet Cupcakes",
        description: "Beautifully decorated cupcakes available with different buttercreams, ganaches, and toppers.",
        imageId: "offering-cupcakes",
        customizationGroups: [
          customizationGroups.cupcakeBase,
          customizationGroups.cupcakeFrostingType,
          customizationGroups.cupcakeFrostingFlavor,
          customizationGroups.cupcakeTopperType,
          customizationGroups.cupcakeTopperShape,
        ],
      },
      {
        id: "offering-madeleines",
        name: "Classic Madeleines",
        description: "Soft, buttery, and shell-shaped little cakes, perfect with tea or coffee.",
        imageId: "offering-madeleines",
        customizationGroups: [
          customizationGroups.madeleineBase,
          customizationGroups.madeleineCoatingType,
          customizationGroups.madeleineCoatingFlavor,
          customizationGroups.madeleineFillingType,
          customizationGroups.madeleineFillingFlavor,
        ],
      },
      {
        id: "offering-viennoiserie",
        name: "Viennoiserie Selection",
        description: "Classic French pastries, baked fresh daily.",
        imageId: "offering-viennoiserie",
        customizationGroups: [
          customizationGroups.viennoiserieType,
          customizationGroups.viennoiserieFilling,
          customizationGroups.viennoiserieTopping,
        ],
      },
      {
        id: "offering-cakes",
        name: "Custom Cakes",
        description: "Stunning multi-tiered cakes, custom-designed to match your theme.",
        imageId: "offering-wedding-cake",
        customizationGroups: [
          customizationGroups.cakeTiers,
          customizationGroups.cakeFlavor,
          customizationGroups.cakeFillingType1,
          customizationGroups.cakeFillingFlavor1,
          customizationGroups.cakeFillingType2,
          customizationGroups.cakeFillingFlavor2,
          customizationGroups.cakeDecorationType,
          customizationGroups.cakeInspirationImages,
        ],
      },
    ],
  },
  {
    id: "savory-bites-catering",
    name: "Savory Bites Catering",
    specialty: "Savory",
    description: "Gourmet appetizers, main courses, and savory platters for events.",
    imageId: "culinary-savory-1",
    offerings: [
      {
        id: "offering-empanadas",
        name: "Empanadas",
        description: "Golden pastries with a variety of savory fillings, either fried or baked.",
        imageId: "offering-empanadas",
        customizationGroups: [
          customizationGroups.empanadaCookingMethod,
          customizationGroups.empanadaFilling,
        ],
      },
      {
        id: "offering-croquettes",
        name: "Croquettes",
        description: "Crispy, creamy, and fried to perfection. A classic Spanish tapa.",
        imageId: "offering-croquettes",
        customizationGroups: [customizationGroups.croquetteType],
      },
      {
        id: "offering-tapas",
        name: "Tapas Selection",
        description: "A curated selection of the most popular Spanish tapas.",
        imageId: "offering-tapas",
        customizationGroups: [customizationGroups.tapasType],
      },
      {
        id: "offering-tunisian-salees",
        name: "Tunisian Mini Salées",
        description: "A flavorful assortment of traditional Tunisian savory bites.",
        imageId: "offering-tunisian-salees",
        customizationGroups: [customizationGroups.tunisianSaleeType],
      },
    ],
  },
  {
    id: "the-confectionery-corner",
    name: "The Confectionery Corner",
    specialty: "Sweet",
    description: "Artisanal chocolates, candies, and custom dessert tables.",
    imageId: "culinary-sweet-2",
    offerings: [
      {
        id: "offering-chocolates",
        name: "Artisanal Chocolates",
        description: "Handcrafted chocolates with a variety of fillings, flavors, and cocoa percentages.",
        imageId: "offering-chocolates",
        customizationGroups: [
          customizationGroups.chocolateType,
          customizationGroups.chocolateFlavor,
          customizationGroups.chocolateCenter,
        ],
      },
      {
        id: "offering-tunisian-sweets",
        name: "Tunisian Sweets",
        description: "A selection of traditional Tunisian pastries, rich with nuts and honey.",
        imageId: "offering-tunisian-sweets",
        customizationGroups: [
          customizationGroups.tunisianSweetsType,
          customizationGroups.tunisianSweetsNuts,
          customizationGroups.ghraibaFlourType,
        ],
      },
      {
        id: "offering-candies",
        name: "Gourmet Candies",
        description: "A delightful assortment of handmade candies, from fruity gummies to rich caramels.",
        imageId: "offering-candies",
        customizationGroups: [customizationGroups.candyType],
      },
    ],
  },
  {
    id: "gourmet-gatherings",
    name: "Gourmet Gatherings",
    specialty: "Savory",
    description: "Full-service catering with a focus on fresh, local ingredients and bold flavors.",
    imageId: "culinary-savory-2",
    offerings: [
      {
        id: "offering-burgers",
        name: "Custom Burgers",
        description: "Build your own gourmet burger with a selection of fresh buns, meats, sauces, and toppings.",
        imageId: "offering-burgers",
        customizationGroups: [
          customizationGroups.burgerBun,
          customizationGroups.burgerMeatType,
          customizationGroups.burgerMeatStyle,
          customizationGroups.burgerSauces,
          customizationGroups.burgerToppings,
        ],
      },
      {
        id: "offering-fries",
        name: "Gourmet Fries",
        description: "Choose your favorite type of fries and dipping sauces.",
        imageId: "offering-fries",
        customizationGroups: [
          customizationGroups.friesType,
          customizationGroups.friesDippingSauces,
        ],
      },
      {
        id: "offering-sushi",
        name: "Sushi Platter",
        description: "A selection of fresh, hand-rolled sushi.",
        imageId: "offering-sushi",
        customizationGroups: [
          customizationGroups.sushiType,
          customizationGroups.sushiFilling,
        ],
      },
      {
        id: "offering-pasta",
        name: "Pasta Station",
        description: "Create your own pasta dish or choose from our filled ravioli.",
        imageId: "offering-pasta",
        customizationGroups: [
          customizationGroups.pastaStyle,
          customizationGroups.pastaShape,
          customizationGroups.pastaSauce,
          customizationGroups.ravioliFilling,
        ],
      },
    ],
  },
];
